// extracted by mini-css-extract-plugin
var _1 = "EntityProfileHeader-moduleEntityProfileHeader__q1KA3";
var _2 = "EntityProfileHeader-moduleshadow__d7HpN";
var _3 = "EntityProfileHeader-modulestickyTitle__L2RFc";
export { _1 as "EntityProfileHeader", _2 as "shadow", _3 as "stickyTitle" }
